import React from 'react';
import {ProgressBar} from "react-bootstrap";
import {faSmile} from "@fortawesome/free-solid-svg-icons/faSmile";
import {faFrown} from "@fortawesome/free-solid-svg-icons/faFrown";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslation} from "react-i18next";

const ProviderNPSCounter = (props) => {
    const {t} = useTranslation();
    return <>
        <div
            style={{
                display: "flex",
                alignItems: "center",
                flexWrap: 'wrap'
            }}
        >
            <h5
                style={
                    {
                        flexShrink: 1,
                        flexGrow: 1,
                        flexBasis: 'max-content',
                        paddingRight: '1rem',
                        marginBottom: '0.5rem'
                    }
                }
            >{t("Provider.ratings")}</h5>
        </div>
        <div
            style={
                {

                }
            }
        >
            <div
                style={
                    {
                        marginTop: '1rem',
                        paddingTop: '2rem',
                    }
                }
            >
                <div
                    style={
                        {
                            display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'column'
                        }
                    }
                >
                    <div
                        style={
                            {
                                flexShrink: 1,
                                flexGrow: 1,
                                display: 'flex',
                                justifyContent: 'center'
                            }
                        }
                    >
                        <div
                            style={
                                {
                                    border: '2px solid lightgray',
                                    borderRadius: '0.65rem'
                                }
                            }
                        >
                            <div
                                style={
                                    {
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: '4rem',
                                        height: '4rem',
                                        background: 'rgba(0, 0, 0, 0) linear-gradient(0deg, rgb(91, 101, 119) 0%, rgb(191, 208, 215) 100%) repeat scroll 0% 0%',

                                        margin: '2px',
                                        borderRadius: '7px',
                                    }
                                }
                            >
                                <div style={
                                    {
                                        fontFamily: "Ubuntu",
                                        fontSize: "1.5rem",
                                        fontWeight: '400',
                                        color: '#fff'
                                    }
                                }
                                >{props.APIDataProvider.reviews && parseInt((props.APIDataProvider.reviews.nps * 100)).toString()}</div>
                            </div>
                        </div>
                    </div>
                    <div
                        style={
                            {
                                flexShrink: 1,
                                flexGrow: 1,
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '0.75rem',
                            }
                        }
                    >
                        <span>
                            {
                                props.APIDataProvider.reviews.total_votes > 0 ?
                                    <span className="text-muted">{props.APIDataProvider.reviews.total_votes} {t("Provider.x-votes-total")}</span> :
                                    <span className="text-muted">{t("Provider.no-votes")}</span>
                            }
                        </span>
                    </div>

                </div>
            </div>
            <div
                style={
                    {
                        display: 'flex',
                        flexWrap: 'no-wrap',
                        marginTop: '1.75rem',
                        paddingTop: '1.75rem',
                        borderTop: '1px solid #ddd'
                    }
                }
            >
                <div
                    style={
                        {
                            minWidth: '2rem',
                            display: 'flex',
                            justifyContent: 'center',
                            fontSize: '0.875rem',
                            color: '#8f8f8f',
                        }
                    }
                >
                    <div
                        style={
                            {
                                border: '1px solid rgba(0,0,0,0.05)',
                                borderRadius: '2rem',
                                height: '1.25rem',
                                width: '1.25rem',
                                lineHeigth: 1,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }
                        }
                    >
                        <FontAwesomeIcon icon={faFrown} style={{verticalAlign: 'baseline'}} />
                    </div>
                </div>
                <div
                    style={
                        {
                            flexBasis: 'max-content',
                            display: 'flex',
                            flexDirection: 'column',
                            flexGrow: 1,
                            flexShrink: 1,
                            marginTop: '0.2rem'
                        }
                    }
                >

                    <div
                        style={
                            {
                                display: 'flex',
                                flexBasis: 'max-content',
                                flexGrow: 1,
                                flexShrink: 1,
                                marginLeft: '0.5rem',
                                marginRight: '0.5rem',
                                position: 'relative',
                            }
                        }
                    >
                        <div
                            style={{
                                flexGrow: 1,
                                height: "14px",
                                borderRadius: "1rem",
                                overflow: 'hidden',
                                position: 'relative',
                                background: 'rgba(0,0,0,0.05)',
                                display: 'flex',
                                padding: '1px'
                                // maxWidth: '5rem'
                            }}
                        >
                            <div
                                style={
                                    {
                                        position: 'absolute',
                                        left: '7px',
                                        right: '7px',
                                        top: 0,
                                        bottom: 0
                                    }
                                }
                            >
                                <div
                                    style={
                                        {
                                            position: 'absolute',
                                            width: 0,
                                            top: 0,
                                            bottom: 0,
                                            left: props.APIDataProvider.reviews ? `${(parseInt((props.APIDataProvider.reviews.nps * 100)) + 100) / 2}%` : '50%'
                                        }
                                    }
                                >
                                    <div
                                        style={
                                            {
                                                background: '#fff',
                                                padding: '5px',
                                                border: '1px solid gray',
                                                borderRadius: '2rem',
                                                position: 'absolute',
                                                top: '1px',
                                                left: '-6px',
                                                zIndex: 1,
                                            }
                                        }
                                    >
                                    </div>
                                </div>
                            </div>
                            <ProgressBar style={
                                {
                                    background: 'linear-gradient(80deg, rgba(223,47,64,1) 0%, rgba(124,124,124,1) 50%, rgba(25,205,99,1) 100%)',
                                    width: '100%',
                                    border: '3px solid #fff',
                                    borderRadius: '1rem',
                                    height: 'auto'
                                }
                            } />
                        </div>
                    </div>
                    <div
                        style={{
                            marginTop: "0.35rem",
                            display: 'flex',
                            flexWrap: 'no-wrap',
                        }}
                    >
                        <div
                            style={
                                {
                                    display: 'flex',
                                    width: '100%',
                                    justifyContent: 'space-between'
                                }
                            }
                        >
                            <div
                                style={
                                    {
                                        minWidth: '3rem',
                                        textAlign: 'center',
                                        fontSize: '0.7rem',
                                        color: 'gray'
                                    }
                                }
                            >
                                -100
                                                    </div>
                            <div

                                style={
                                    {
                                        minWidth: '3rem',
                                        textAlign: 'center',
                                        fontSize: '0.7rem',
                                        color: 'gray'
                                    }
                                }
                            >

                                0
                                                    </div>
                            <div
                                style={
                                    {
                                        minWidth: '3rem',
                                        textAlign: 'center',
                                        fontSize: '0.7rem',
                                        color: 'gray'
                                    }
                                }
                            >
                                100
                </div>
                        </div>
                    </div>
                </div>
                <div
                    style={
                        {
                            minWidth: '2rem',
                            display: 'flex',
                            justifyContent: 'center',
                            fontSize: '0.875rem',
                            color: '#8f8f8f',
                        }
                    }
                >
                    <div
                        style={
                            {
                                border: '1px solid rgba(0,0,0,0.05)',
                                borderRadius: '2rem',
                                height: '1.25rem',
                                width: '1.25rem',
                                lineHeigth: 1,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }
                        }
                    >
                        <FontAwesomeIcon icon={faSmile} style={{verticalAlign: 'baseline'}} />
                    </div>
                </div>
            </div>

        </div>
    </>
}

export default ProviderNPSCounter;
